/* Request a Call — PDP section: reveal animation, live product context, submit UX */
(function () {
  "use strict";

  function initSection(section) {
    if (section.dataset.rcInit) return;
    section.dataset.rcInit = "1";

    /* ---- Reveal on scroll ---- */
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              section.classList.add("rc--in");
              io.disconnect();
            }
          });
        },
        { threshold: 0.14, rootMargin: "0px 0px -8% 0px" }
      );
      io.observe(section);
    } else {
      section.classList.add("rc--in");
    }

    /* ---- Live product / variant / upgrades context ---- */
    var variantLine = section.querySelector("[data-rc-variant]");
    var variantHidden = section.querySelector("[data-rc-variant-input]");
    var upgradesWrap = section.querySelector("[data-rc-upgrades]");
    var upgradesList = section.querySelector("[data-rc-upgrades-list]");
    var upgradesHidden = section.querySelector("[data-rc-upgrades-input]");

    function getProductData() {
      var d = window.productDataSection;
      return d && d.variants ? d : null;
    }

    function selectedVariant() {
      var data = getProductData();
      if (!data) return null;
      var input = document.querySelector('.product-form input[name="id"]');
      var id = input ? parseInt(input.value, 10) : null;
      if (!id) return null;
      return data.variants.filter(function (v) { return v.id === id; })[0] || null;
    }

    function variantLabel(v) {
      var data = getProductData();
      if (!v || !data || !data.options) return "";
      if (v.title === "Default Title") return "";
      var opts = v.options || [];
      var names = data.options.map(function (o) { return o.name || o; });
      return names
        .map(function (n, i) { return opts[i] ? n + ": " + opts[i] : null; })
        .filter(Boolean)
        .join("  ·  ");
    }

    function collectUpgrades() {
      var inputs = document.querySelectorAll('[data-upsell-variant-input][data-has-value="true"]');
      var titles = [];
      inputs.forEach(function (inp) {
        var wrap = inp.closest(".product-upsell__item-wrap");
        var t = wrap && wrap.querySelector(".product-upsell__item-title");
        if (t) titles.push(t.textContent.trim());
      });
      return titles;
    }

    function update() {
      var v = selectedVariant();
      var label = variantLabel(v);
      if (variantLine) {
        if (label) { variantLine.textContent = label; variantLine.hidden = false; }
        else { variantLine.textContent = ""; variantLine.hidden = true; }
      }
      if (variantHidden) variantHidden.value = label;

      var ups = collectUpgrades();
      if (upgradesWrap) {
        if (ups.length) {
          if (upgradesList) upgradesList.textContent = ups.map(function (u) { return "• " + u; }).join("\n");
          upgradesWrap.hidden = false;
        } else {
          upgradesWrap.hidden = true;
        }
      }
      if (upgradesHidden) upgradesHidden.value = ups.join(", ");
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; update(); }, 60);
    }

    document.addEventListener("change", function (e) {
      if (e.target && e.target.closest && e.target.closest(".variant-selector-wrapper, .product-variants-accordion")) schedule();
    });
    // Upgrade drawer add/remove are click-driven and set the hidden inputs async.
    document.addEventListener("click", function (e) {
      if (e.target && e.target.closest && e.target.closest("[data-upgrade-drawer-trigger], [data-upgrade-add-to-cart], [data-upgrade-drawer-close]")) schedule();
    });
    update();

    /* ---- Submit UX ---- */
    var form = section.querySelector(".rc__form");
    if (form) {
      form.addEventListener("submit", function () {
        // Ensure context is current at submit time
        update();
        form.classList.add("is-submitting");
      });
    }

    /* ---- Scroll to success message after a successful post ---- */
    var success = section.querySelector(".rc__success");
    if (success) {
      try {
        section.scrollIntoView({ behavior: "smooth", block: "center" });
      } catch (err) {
        section.scrollIntoView();
      }
    }
  }

  function initAll() {
    document.querySelectorAll("[data-request-call-section]").forEach(initSection);
  }

  /* Links to #request-call (e.g. "Want a different look?" under Add to Cart):
     smooth-scroll to the form (Lenis-aware), optionally pre-select a topic, then focus the name field. */
  document.addEventListener("click", function (e) {
    var link = e.target.closest && e.target.closest('a[href="#request-call"]');
    if (!link) return;
    var target = document.getElementById("request-call");
    if (!target) return;
    e.preventDefault();
    var topic = link.getAttribute("data-rc-topic");
    if (topic) {
      var radios = target.querySelectorAll('.rc__topic-input');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === topic) { radios[i].checked = true; radios[i].dispatchEvent(new Event("change", { bubbles: true })); }
      }
    }
    var header = document.querySelector(".header-wrapper, header");
    var offset = header ? -(header.getBoundingClientRect().height + 16) : -80;
    var focusName = function () {
      var name = target.querySelector('input[name="contact[name]"]');
      if (name) { try { name.focus({ preventScroll: true }); } catch (err) { name.focus(); } }
    };
    if (window.lenis && typeof window.lenis.scrollTo === "function") {
      window.lenis.scrollTo(target, { offset: offset, duration: 1.1, onComplete: focusName });
    } else {
      var y = target.getBoundingClientRect().top + window.scrollY + offset;
      window.scrollTo({ top: y, behavior: "smooth" });
      setTimeout(focusName, 700);
    }
    if (history.replaceState) history.replaceState(null, "", "#request-call");
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  // Theme editor
  document.addEventListener("shopify:section:load", function (e) {
    var s = e.target.querySelector("[data-request-call-section]");
    if (s) initSection(s);
  });
})();
